/* East Coast Bakes — theme.js */

// Mobile menu toggle
document.querySelectorAll('.menu-toggle').forEach(btn => {
  btn.addEventListener('click', () => {
    const nav = document.querySelector('.mobile-nav');
    if (nav) nav.classList.toggle('is-open');
  });
});

// Product detail: gallery thumbnails
document.querySelectorAll('.pdp__thumbs button').forEach(btn => {
  btn.addEventListener('click', () => {
    const src = btn.querySelector('img').getAttribute('src');
    const main = document.querySelector('.pdp__main-image img');
    if (main) main.setAttribute('src', src.replace('width=400', 'width=1400'));
    document.querySelectorAll('.pdp__thumbs button').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  });
});

// Quantity stepper
document.querySelectorAll('.pdp__qty').forEach(wrap => {
  const input = wrap.querySelector('input');
  wrap.querySelector('[data-step="-1"]')?.addEventListener('click', () => {
    input.value = Math.max(1, parseInt(input.value || 1) - 1);
  });
  wrap.querySelector('[data-step="1"]')?.addEventListener('click', () => {
    input.value = parseInt(input.value || 1) + 1;
  });
});

// Fade-up animation on scroll
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-in'); });
}, { threshold: 0.15 });
document.querySelectorAll('.fade-up').forEach(el => io.observe(el));
